module.exports = __webpack_public_path__ + "static/media/cht_2.b9f5e4ae.jpg";